/* istanbul ignore file */

export enum MFEPackageIds {
  PORTFOLIO_BUILDER_PKG = 'portfolio-builder-pkg',
  RISK_QUIZ_PKG_ROE = 'risk-quiz-pkg-roe',
  SETTLEMENT_FUND_PKG = 'settlement-fund-pkg',
  DOC_UPLOAD_PKG = 'document-upload-pkg',
  CDD_BANNER_PKG = 'cdd-banner-pkg',
  SECURELINK_PKG = 'securelink-pkg',
  EMPLOYMENT_PKG = 'employment-pkg',
  INVESTMENT_OBJECTIVES_PKG = 'investment-objectives-pkg',
  PERSONAL_INFO_CLIENT_PKG = 'personal-info-client-pkg',
  INCOME_NETWORTH_PKG = 'income-networth-pkg',
  PERSONAL_ADDRESS_PKG = 'personal-address-pkg',
  WLD_DOC_UPLOAD_PKG = 'wld-doc-upload-pkg',
  PHONE_PKG = 'phone-pkg',
}

export const MAX_RETRIES = 3;

export const NO_MANIFEST_PACKAGES = new Set<string>([
  MFEPackageIds.SETTLEMENT_FUND_PKG,
  MFEPackageIds.PORTFOLIO_BUILDER_PKG,
  MFEPackageIds.RISK_QUIZ_PKG_ROE,
  MFEPackageIds.WLD_DOC_UPLOAD_PKG,
]);
